import { combineReducers } from 'redux'

import { makeCommunicationByIdReducer } from 'shared/utils/communication/reducer/makeCommunicationByIdReducer'
import { makeCommunicationReducer } from 'shared/utils/communication/reducer/makeCommunicationReducer'

import * as actions from '../actions'
import { IAuthState } from '../types'

export default combineReducers<IAuthState['communications']>({
  login: makeCommunicationReducer(actions.signIn),
  logout: makeCommunicationReducer(actions.logout),
  signUp: makeCommunicationReducer(actions.signUp),
  resendEmail: makeCommunicationReducer(actions.resendEmail),
  getAgentLinks: makeCommunicationReducer(actions.getAgentLinks),
  verifyEmail: makeCommunicationReducer(actions.verifyEmail),
  resetPassword: makeCommunicationReducer(actions.resetPassword),
  resetPasswordConfirm: makeCommunicationReducer(actions.resetPasswordConfirm),
  updateUserData: makeCommunicationReducer(actions.updateUserData),
  refreshSession: makeCommunicationReducer(actions.refreshSession),
})
